<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	import imageBuilder from 'utils/sanity/sanityImage';

	export let portableText: CustomBlockComponentProps<{
		imageCapture?: string;
		asset: {
			_ref: string;
			_type: string;
		};
		style?: string;
	}>;

	const imgSrc = imageBuilder.image(portableText?.value?.asset?._ref).format('webp').url();
</script>

{#if imgSrc}
	<div class="picture-wrapper">
		<img class="secondary-picture"
			src={imgSrc}
			alt={portableText?.value?.imageCapture || ''}
			loading="lazy"
		/>
	</div>
{/if}

<style lang="scss">
	@import 'sanityImage';
</style>
